import {
  BookingType,
  EventBookAPIType,
  EventBookRequest,
} from "~/types/event/event.types";

import { sendRequest } from "../clients/axios";

export const bookEventById = async (input: EventBookAPIType) => {
  const { guests, eventId } = input;
  const res = await sendRequest<EventBookRequest, BookingType>({
    method: "post",
    url: `/event/book/${eventId}`,
    data: { guests },
  });
  return res.data;
};
